import axios from "axios";
import { getApiBaseUrl, getApiClient } from "./serviceconfig";
import { isAuthSessionValid, markAuthTokenVerified, getResolvedAuthToken, isAuthTokenVerified } from "../utils/authSession";

var apiBaseUrl = getApiBaseUrl();

// export async function getLogo() {
//   let url= `${apiBaseUrl}/login/`;
//     return axios.get(url)
//       .then(response => response.data);
// }

export async function getBgImageLogo() {
  const url = `${apiBaseUrl}/set_bg_image_logo/`;
  try {
    const response = await axios.get(url, { timeout: 10000 });
    return { ...response.data, apiOffline: false };
  } catch (error) {
    const noResponse = !error.response;
    const isNetworkFailure = noResponse && (
      error.code === 'ECONNABORTED'
      || error.code === 'ERR_NETWORK'
      || error.message === 'Network Error'
    );
    if (isNetworkFailure) {
      console.warn('Backend unreachable at', apiBaseUrl, error?.message || error);
      return { company_list: [], apiOffline: true };
    }
    console.warn('Unable to load background/logo settings:', error?.message || error);
    return { company_list: [], apiOffline: false };
  }
}

export async function submitLogin(user_name, password,otp,latitude,longitude) {
  try {
    const response = await axios.post(`${apiBaseUrl}/login/`, {
      username: user_name.trim(),
      password: password,
      otp : otp,
      latitude:latitude,
      longitude:longitude
    }, { timeout: 15000 });
    return response.data;
  } catch (error) {
    error.__authHandled = true;
    throw error;
  }
}

export async function verifyAuthToken(cookies) {
  const token = getResolvedAuthToken(cookies);
  if (!token || !isAuthSessionValid(token)) {
    return false;
  }
  if (isAuthTokenVerified(token)) {
    return true;
  }
  try {
    await getApiClient({ myToken: token }).get(`${apiBaseUrl}/entity_plant/user_allowed/`);
    markAuthTokenVerified(token);
    return true;
  } catch {
    return false;
  }
}

export async function getSessionProfile(cookies) {
  const token = getResolvedAuthToken(cookies);
  if (!token) {
    return null;
  }
  return getApiClient({ myToken: token })
    .get(`${apiBaseUrl}/session/`)
    .then((response) => response.data);
}

export async function performLogout(cookies) {
  try {
    await getApiClient(cookies).post(`${apiBaseUrl}/logout/`);
  } catch (error) {
    const status = error?.response?.status;
    // Token may already be invalid/expired — local logout should still succeed.
    if (status !== 401 && status !== 403) {
      throw error;
    }
  }
}